import styled from 'styled-components'

import UniversalButtonText from '../../../components/elements/UniversalButton/UniversalButtonText'

const ButtonText = styled(UniversalButtonText)`
  
`

export default ButtonText
